// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormTag_wrapper__2pyX5","tag":"FormTag_tag__3f1-6","button":"FormTag_button__1fU2N"};